import React, { Component } from 'react';
import { Route, Router, Routes } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";
import AppRoutes from './AppRoutes';
import { LayoutDashboard } from './Components/DashboardComponent/LayoutDashboard';
import 'react-toastify/dist/ReactToastify.css';
import '@progress/kendo-theme-default/dist/all.css';

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msalInstance: props.msalInstance,
        }
    }
    static displayName = App.name;

    componentDidMount() {
    }
    render() {
        return (
            <LayoutDashboard >
                <Routes >
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route  key={index} {...rest} showToast={this.showToast} element={element} />;
                    })}
                </Routes>
                </LayoutDashboard>
        );
    }
}
